import { render, staticRenderFns } from "./OtherLabourListSideMenu.vue?vue&type=template&id=32a5f159&scoped=true"
import script from "./OtherLabourListSideMenu.vue?vue&type=script&lang=js"
export * from "./OtherLabourListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./OtherLabourListSideMenu.vue?vue&type=style&index=0&id=32a5f159&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a5f159",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32a5f159')) {
      api.createRecord('32a5f159', component.options)
    } else {
      api.reload('32a5f159', component.options)
    }
    module.hot.accept("./OtherLabourListSideMenu.vue?vue&type=template&id=32a5f159&scoped=true", function () {
      api.rerender('32a5f159', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/otherlabour/OtherLabourListSideMenu.vue"
export default component.exports